<script>
import BaseUgcTool from "../BaseUgcTool";

import { sessionKeys } from '@/data/constants';

export default {
  name: "UgcReplaceImageControl",

  extends: BaseUgcTool,

  created() {
    // Region is APAC OR Vuex was already populated by contact details
    // Or forceAndConditions is false
    const {
      ugcFeature = null,
      ugc_image_id = null,
      replaceComponentFeature,
      activeUGCComponent,
      storeMultipleUGCsizes
    } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];

    const isComponentLibrary = this.$recipe.checkForImageLibraryComponent(activeUGCComponent);
    if (this.$store.state.ugc.tempData.activeUGCIndex === 1 &&
    ((storeMultipleUGCsizes && isComponentLibrary) || !storeMultipleUGCsizes)) {
      this.$eventBus.$emit('image-library-close-ugc', {isReplaceTool: true});
      this.$eventBus.$emit('replace-image-library-tool');
    } else if (!this.$store.state.utils.configuration.ugc.forceUgcTermConditions
      && (((this.$store.getters['utils/regionIsApac'] || this.$store.getters['utils/tmallEnabled']) && !!this.$cookies.get(sessionKeys.ugcTermsConditionsAccepted))
        || (!!Object.keys(this.$store.state.UGCEntryPoint.contactDetails).length || !this.$store.state.utils.configuration.ugc.enableUGCContactDetails))) {
      document.getElementsByClassName("ugc-uploader-label")[0].click();
    } else { // User data undefined
      this.$modal.show(this.$store.state.utils.configuration.ugc.enableNewUgcTermConditions ? "newTermsConditionModal" : "termsConditionModal");
    }
  },
  render() {
    return null;
  }
};
</script>
